import axiosInstance from '../../axios-config';

const capabilitiesApi = '/api/users/{0}/capabilities/patientPortal';

const systemCapabilitiesApi = '/api/SystemCapabilities?portalType=patientPortal';


const supportedLanguagesApi = 'api/SystemCapabilities/SupportedLanguages';

export const getCapabilities = (userId) => (
  axiosInstance.get(capabilitiesApi.replace('{0}', userId))
);

export const getSystemCapabilities = () => (
  axiosInstance.get(systemCapabilitiesApi)
);

export const getSupportedLanguages = () => (
  axiosInstance.get(supportedLanguagesApi)
);
